import { createUnifiedRestApi } from "../utils.js";
import ExperimentUnifiedResourceInstance from "../../../../resources/expapiunified/Experiment.unified.resource.js";
const builder = createUnifiedRestApi(
  ExperimentUnifiedResourceInstance,
  "experiments",
  (state) => state.experiments
);
const {
  actions: startActions,
  isOfType: isExperimenStart,
  selectAsyncRequest: selectStartExperimentAsyncRequest
} = builder.addCreateOrUpdateAction(
  "START_ASYNC",
  (inputPayload) => ExperimentUnifiedResourceInstance.startAsync(inputPayload.workspaceId, inputPayload.id)
);
const {
  actions: stopActions,
  isOfType: isExperimentStop,
  selectAsyncRequest: selectStopExperimentAsyncRequest
} = builder.addCreateOrUpdateAction(
  "STOP_ASYNC",
  (inputPayload) => ExperimentUnifiedResourceInstance.stopAsync(inputPayload.workspaceId, inputPayload.id)
);
const {
  actions: advanceActions,
  isOfType: isExperimentAdvance,
  selectAsyncRequest: selectAdvanceExperimentAsyncRequest
} = builder.addCreateOrUpdateAction(
  "ADVANCE_ASYNC",
  (inputPayload) => ExperimentUnifiedResourceInstance.advanceAsync(inputPayload.workspaceId, inputPayload.id)
);
const {
  actions: getExperimentOperationChecksActions,
  isOfType: isGetExpermentOperationChecks,
  selectAsyncRequest: selectGetExperimentOperationChecksAsyncRequest
} = builder.addGetAction(
  "GET_OPERATION_CHECKS_ASYNC",
  (inputPayload) => ExperimentUnifiedResourceInstance.getOperationsAsync(inputPayload.workspaceId, inputPayload.id)
);
const startExperimentAsync = (inputPayload) => startActions.load({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const stopExperimentAsync = (inputPayload) => stopActions.load({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const advanceExperimentAsync = (inputPayload) => advanceActions.load({ workspaceId: inputPayload.workspaceId, id: inputPayload.id, entity: void 0 });
const {
  epic: experimentsEpic,
  reducer: experimentsReducer,
  actions: experimentsActions,
  matchers: experimentsMatchers,
  selectors,
  getDefaultReducerState: getDefaultExperimentsReducerState
} = builder.create();
const {
  selectAll: selectAllExperiments,
  selectById: selectExperimentById,
  selectGetAsyncRequest: selectGetExperimentAsyncRequest,
  selectCreateOrUpdateAsyncRequest: selectCreateOrUpdateExperimentAsyncRequest,
  selectDeleteAsyncRequest: selectDeleteExperimentAsyncRequest,
  selectQueryAsyncRequest: selectQueryExperimentsAsyncRequest
} = selectors;
const {
  getAsync: getExperimentAsync,
  createOrUpdateAsync: createOrUpdateExperimentAsync,
  deleteAsync: deleteExperimentAsync,
  queryAsync: queryExperimentsAsync
} = experimentsActions;
const { load: getExperimentOperationChecksAsync } = getExperimentOperationChecksActions;
export {
  advanceExperimentAsync,
  createOrUpdateExperimentAsync,
  deleteExperimentAsync,
  experimentsEpic,
  experimentsMatchers,
  experimentsReducer,
  getDefaultExperimentsReducerState,
  getExperimentAsync,
  getExperimentOperationChecksAsync,
  isExperimenStart,
  isExperimentAdvance,
  isExperimentStop,
  isGetExpermentOperationChecks,
  queryExperimentsAsync,
  selectAdvanceExperimentAsyncRequest,
  selectAllExperiments,
  selectCreateOrUpdateExperimentAsyncRequest,
  selectDeleteExperimentAsyncRequest,
  selectExperimentById,
  selectGetExperimentAsyncRequest,
  selectGetExperimentOperationChecksAsyncRequest,
  selectQueryExperimentsAsyncRequest,
  selectStartExperimentAsyncRequest,
  selectStopExperimentAsyncRequest,
  startExperimentAsync,
  stopExperimentAsync
};
//# sourceMappingURL=experiments.js.map
